import { IReduxAction, actionGenerator } from '../../utils/actions';
import { IAdaptiveSettings } from '../../types/layout';

export const UPDATE_ADAPTIVE_SETTINGS = 'LAYOUT :: ADAPTIVE_SETTINGS :: UPDATE';

export type TUpdateAdaptiveSettingsAction = IReduxAction<typeof UPDATE_ADAPTIVE_SETTINGS, IAdaptiveSettings>;

export const updateAdaptiveSettings = actionGenerator<typeof UPDATE_ADAPTIVE_SETTINGS, IAdaptiveSettings>(
  UPDATE_ADAPTIVE_SETTINGS,
);
